import React, { useState, useEffect, Fragment } from 'react'
import { useDispatch } from 'react-redux'
import { Card } from 'react-bootstrap'
import Pagination from '../../components/Nav/Pagination'
import configs from '../../config'
import Cookies from 'js-cookie'
import TabStatus from './TabStatus'
import DropdownDate from './DropdownDate'
import Search from './Search'
import LotteryList from './LotteryList'
import UserModal from '../User/UserModal'
import UserInfo from './UserInfo'
import axios from 'axios'
import config from '../../config'
import { getRounds } from '../../services/config-services'
import { useSelector } from 'react-redux'

const Lottery = () => {
  const dispatch = useDispatch()
  const [roundDate, setRoundDate] = useState('')
  const [lotteries, setLotteries] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [searchText, setSearchText] = useState('')
  const [status, setStatus] = useState('ALL')
  const [digitsSearchType, setDigitsSearchType] = useState('')
  const [rounds, setRounds] = useState([])
  const [forceUpdate, setForceUpdate] = useState(false)
  const [lengthDigit, setLengthDigit] = useState(6)
  const [userModalVisible, setUserModalVisible] = useState(false)
  const [selectedUser, setSelectedUser] = useState({})
  const [openInfo, setOpenInfo] = useState(false)
  const { isRoundClosed } = useSelector((state) => state.webConfig)

  const fetchLotteries = async (page, searchText, status, digitsSearchType, roundDate) => {
    const params = new URLSearchParams()
    params.append('page', page)

    switch (digitsSearchType) {
      case 'LAST_THREE_DIGITS':
        params.append('number', `...${searchText}`)
        break
      case 'LAST_TWO_DIGITS':
        params.append('number', `....${searchText}`)
        break
      case 'FIRST_THREE_DIGITS':
        params.append('number', `${searchText}...`)
        break
      default:
        searchText = searchText.length === 6 ? searchText : '......'
        params.append('number', `${searchText}`)
        break
    }

    if (status) {
      params.append('status', status)
    }

    if (roundDate) {
      params.append('roundDate', roundDate)
    }

    try {
      dispatch({ type: 'loading_show' })
      const requestUrl = `${configs.apiAdminGateway}/api/v2/admin/lotteries?${params.toString()}&isPublish=true`
      const getAccessToken = Cookies.get('accessToken')
      const myHeaders = new Headers()
      myHeaders.append('Authorization', `Bearer ${getAccessToken}`)
      myHeaders.append('Content-Type', 'application/json')
      fetch(requestUrl, { method: 'GET', headers: myHeaders })
        .then((response) => response.json())
        .then(async (result) => {
          setLotteries(result.data)
          dispatch({ type: 'loading_hide' })
        })
    } catch (err) {
      setLotteries([])
      dispatch({ type: 'loading_hide' })
    }
  }

  useEffect(() => {
    const fetchAllRounds = async () => {
      const data = await getRounds()
      setRoundDate(data[0].value)
      setRounds(data.map((r) => ({ roundDate: r.value })))
    }
    fetchAllRounds()
  }, [dispatch])

  useEffect(() => {
    fetchLotteries(currentPage, searchText, status, digitsSearchType, roundDate)
  }, [forceUpdate, currentPage, status, roundDate])

  const onChangePage = (page) => {
    setCurrentPage(page)
  }

  const handleOnChange = (e) => {
    e.preventDefault()
    fetchLotteries(currentPage, searchText, status, digitsSearchType, roundDate)
  }

  const clearSearch = () => {
    setSearchText('')
    setDigitsSearchType('')
    setStatus('ALL')
    setCurrentPage(1)
    setForceUpdate(!forceUpdate)
    setLengthDigit(6)
  }

  const fetchUsers = async (userIdOrPhone) => {
    if (userIdOrPhone.length === 0) return
    try {
      dispatch({ type: 'loading_show' })
      const query = {
        userId: userIdOrPhone,
      }
      const result = await axios.get(`${config.apiAdminGateway}/api/v1/admin/users`, {
        params: query,
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      })

      const {
        status: { code, description },
        data,
      } = result.data

      if (code !== 0) {
        throw new Error(description)
      }

      setSelectedUser(
        data.map((d) => {
          const bd = new Date(d.birthDay)
          return {
            ...d,
            birthDay: { year: bd.getFullYear(), month: bd.getMonth() + 1, day: bd.getDate() },
            ownerBankName: d.bankName,
            ownerBankNo: d.bankNo,
          }
        })[0],
      )
      setUserModalVisible(true)
      dispatch({ type: 'loading_hide' })
    } catch (error) {
      setSelectedUser([])
      dispatch({ type: 'loading_hide' })
    }
  }

  const onToggleInfo = () => {
    setOpenInfo((prev) => !prev)
  }

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>Lotteries</Card.Title>
        </Card.Header>
        <Card.Body>
          <DropdownDate rounds={rounds} setRoundDate={setRoundDate} />
          <br />
          <TabStatus setStatus={setStatus} status={status} setCurrentPage={setCurrentPage} />
          <Search
            setSearchText={setSearchText}
            handleOnChange={handleOnChange}
            searchText={searchText}
            setDigitsSearchType={setDigitsSearchType}
            setForceUpdate={setForceUpdate}
            forceUpdate={forceUpdate}
            digitsSearchType={digitsSearchType}
            clearSearch={clearSearch}
            fetchLotteries={fetchLotteries}
            roundDate={roundDate}
            status={status}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            setLengthDigit={setLengthDigit}
            lengthDigit={lengthDigit}
          />
          <LotteryList lotteries={lotteries} onUserInfoClick={fetchUsers} isRoundClosed={isRoundClosed} />
          <Pagination
            currentPage={currentPage}
            onPrevPage={() => onChangePage(currentPage - 1)}
            onNextPage={() => onChangePage(currentPage + 1)}
            items={lotteries}
            perPage={20}
          />
          <UserInfo open={openInfo} toggleFn={onToggleInfo} lotteries={lotteries} />
        </Card.Body>
      </Card>
      {userModalVisible && (
        <UserModal
          userModalVisible={userModalVisible}
          setUserModalVisible={setUserModalVisible}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          onClose={() => {
            setUserModalVisible(false)
          }}
        />
      )}
    </Fragment>
  )
}

export default Lottery
